import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import YildizArkaplan from "../components/YildizArkaplan";
import { FALCILAR } from "../data/falcilar";
import { useFal } from "../context/FalContext";
import { useTranslation } from "react-i18next";

export default function Falcilar() {
  const [searchParams] = useSearchParams();
  const seciliFal = searchParams.get("fal");
  const [aktifFiltre, setAktifFiltre] = useState("all");
  const navigate = useNavigate();
  const { falciDurumlar } = useFal();
  const { t } = useTranslation();

  const FILTRELER = [
    { key: "all", label: t("readers.filterAll") },
    { key: "online", label: t("readers.filterOnline") },
    { key: "eco", label: t("readers.filterEco") },
    { key: "premium", label: t("readers.filterPremium") },
  ];

  const FAL_ESLESTIRME = {
    kahve: ["Kahve Falı"],
    el: ["El Falı"],
    yuz: ["Yüz Falı"],
    iliski: ["İlişki Falı", "Aşk & İlişki"],
  };

  const GIZLI_FALCILAR = ["dervis", "lunara"];

  const filtrelenmis = FALCILAR.filter((f) => {
    // Derviş Efendi ve Lunara hiçbir listede gösterilmez
    if (GIZLI_FALCILAR.includes(f.id)) return false;

    // Fal parametresine göre filtreleme
    if (seciliFal && FAL_ESLESTIRME[seciliFal]) {
      const aranan = FAL_ESLESTIRME[seciliFal];
      // Mecnun her zaman gösterilir
      if (f.id === "mecnun") {
        // Mecnun geçer, aşağıdaki UI filtresine devam
      } else if (!f.uzmanlik.some((u) => aranan.includes(u))) {
        return false;
      }
    }

    // UI filtresi
    if (aktifFiltre === "all") return true;
    if (aktifFiltre === "online") return f.online;
    if (aktifFiltre === "eco") return f.token <= 25;
    if (aktifFiltre === "premium") return f.token >= 30;
    return true;
  });

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative",
      fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420,
      margin: "0 auto",
    }}>
      <style>{`
        @keyframes nabiz { 0%, 100% { opacity: 0.6; } 50% { opacity: 1; } }
        @keyframes mesgul-nabiz { 0%, 100% { opacity: 0.8; } 50% { opacity: 0.4; } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 90 }}>

        {/* Header */}
        <div style={{ padding: "24px 24px 20px" }}>
          <div style={{ fontSize: 26, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif" }}>
            {t("readers.title")}
          </div>
          <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", marginTop: 4 }}>
            {t("readers.subtitle")}
          </div>
        </div>

        {/* Filtreler */}
        <div style={{ padding: "0 24px 24px", display: "flex", gap: 8, overflowX: "auto" }}>
          {FILTRELER.map((filtre) => (
            <button
              key={filtre.key}
              onClick={() => setAktifFiltre(filtre.key)}
              style={{
                background: aktifFiltre === filtre.key ? "rgba(168,85,247,0.3)" : "rgba(255,255,255,0.06)",
                border: aktifFiltre === filtre.key ? "1px solid rgba(168,85,247,0.6)" : "1px solid rgba(255,255,255,0.1)",
                borderRadius: 20, padding: "7px 16px", fontSize: 12,
                color: aktifFiltre === filtre.key ? "#C084FC" : "rgba(255,255,255,0.5)",
                cursor: "pointer", whiteSpace: "nowrap", fontWeight: 600, transition: "all 0.2s",
              }}
            >
              {filtre.label}
            </button>
          ))}
        </div>

        {/* Falcı Listesi */}
        <div style={{ padding: "0 24px" }}>
          {filtrelenmis.map((falci) => {
            const mesgul = falciDurumlar[falci.id] || false;
            const kalanDakika = 5;

            return (
              <div
                key={falci.id}
                onClick={() => navigate(seciliFal ? `/fal/${falci.id}/${seciliFal}` : `/falci/${falci.id}`)}
                style={{
                  background: "rgba(255,255,255,0.04)",
                  border: mesgul ? "1px solid rgba(249,203,66,0.3)" : "1px solid rgba(255,255,255,0.08)",
                  borderRadius: 18, padding: "18px", marginBottom: 12,
                  cursor: "pointer", transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.07)";
                  e.currentTarget.style.border = `1px solid ${falci.parlak}44`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.04)";
                  e.currentTarget.style.border = mesgul ? "1px solid rgba(249,203,66,0.3)" : "1px solid rgba(255,255,255,0.08)";
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>

                  {/* Avatar */}
                  <div style={{
                    width: 60, height: 60, borderRadius: 18,
                    background: `${falci.renk}33`, border: `1px solid ${falci.renk}66`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 28, flexShrink: 0, position: "relative",
                  }}>
                    {falci.emoji}
                    <div style={{
                      position: "absolute", bottom: -3, right: -3,
                      width: 14, height: 14, borderRadius: "50%",
                      background: mesgul ? "#F9CB42" : falci.online ? "#34D399" : "#6B7280",
                      border: "2px solid #0a0718",
                      animation: mesgul ? "mesgul-nabiz 1s ease-in-out infinite" : falci.online ? "nabiz 2s ease-in-out infinite" : "none",
                    }} />
                  </div>

                  {/* Bilgiler */}
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div style={{ fontSize: 16, fontWeight: 700, color: "#fff", fontFamily: "Georgia, serif" }}>
                        {falci.isim}
                      </div>
                      <div style={{
                        background: "rgba(249,203,66,0.15)", border: "1px solid rgba(249,203,66,0.3)",
                        borderRadius: 20, padding: "3px 10px", fontSize: 12, color: "#F9CB42", fontWeight: 700,
                      }}>
                        🪙 {falci.token}
                      </div>
                    </div>

                    <div style={{ fontSize: 12, color: falci.parlak, marginTop: 2, fontWeight: 600 }}>
                      {falci.unvan}
                    </div>

                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", marginTop: 4, lineHeight: 1.4 }}>
                      {falci.tanim}
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
                      <div style={{ fontSize: 12, color: "#F9CB42" }}>★ {falci.puan}</div>
                      <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)" }}>
                        ({falci.yorumSayisi} {t("readers.comments")})
                      </div>

                      <div style={{
                        marginLeft: "auto", padding: "3px 10px", borderRadius: 20,
                        fontSize: 11, fontWeight: 700,
                        background: mesgul ? "rgba(249,203,66,0.15)" : falci.online ? "rgba(52,211,153,0.15)" : "rgba(255,255,255,0.06)",
                        color: mesgul ? "#F9CB42" : falci.online ? "#34D399" : "rgba(255,255,255,0.3)",
                        border: mesgul ? "1px solid rgba(249,203,66,0.4)" : falci.online ? "1px solid rgba(52,211,153,0.3)" : "1px solid rgba(255,255,255,0.1)",
                        animation: mesgul ? "mesgul-nabiz 1s ease-in-out infinite" : "none",
                      }}>
                        {mesgul ? t("readers.busy", { min: kalanDakika }) : falci.online ? t("readers.online") : t("readers.offline")}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Alt buton */}
                <div style={{
                  marginTop: 14, padding: "10px", borderRadius: 12,
                  background: mesgul ? "rgba(249,203,66,0.08)" : `${falci.renk}22`,
                  border: mesgul ? "1px solid rgba(249,203,66,0.2)" : `1px solid ${falci.renk}44`,
                  textAlign: "center", fontSize: 13,
                  color: mesgul ? "#F9CB42" : falci.parlak,
                  fontWeight: 600,
                }}>
                  {mesgul ? t("readers.busyBtn") : t("readers.readBtn")}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}